








import {Component, Prop, Vue} from 'vue-property-decorator'
import OptionSelector from "@/components/OptionSelector/OptionSelector.vue";
import UserStore, { USER_TYPES } from '@/store/modules/UserStore'

@Component({
    components: {OptionSelector}
})
export default class MenuOptionSelector extends Vue {
    private readonly ITEM_MENU_CHANGE :number = 1;
    private readonly ITEM_MENU_COPY :number = 2;
    private readonly ITEM_MENU_DELETE :number = 3;
    private menuItems: any = [];

    created() {
        this.menuItems = [];
        this.menuItems.push({id: this.ITEM_MENU_CHANGE, label:'メニュー名変更'});
        // 全店舗ユーザの場合のみメニュー表示
        if (UserStore.userType == USER_TYPES.SUPER_USER) {
            this.menuItems.push({id: this.ITEM_MENU_COPY, label:'メニューコピー'});
        }
        this.menuItems.push({id: this.ITEM_MENU_DELETE, label:'削除'});
    }

    private onChange(id: number): void {
        if (id == this.ITEM_MENU_CHANGE) this.$emit("selectEdit");
        else if (id == this.ITEM_MENU_COPY) this.$emit("selectCopy");
        else if (id == this.ITEM_MENU_DELETE) this.$emit("selectDelete");
    }
}
